var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.8,
    height: 40.437,
    viewBox: "0 0 47.8 40.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personalize",
    transform: "translate(1.4 1.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tshirt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1338",
    "data-name": "Pfad 1338",
    d: "M18.57,1.185l8.983,5.189a2.891,2.891,0,0,1,1.057,3.948l-3.056,5.293A2.89,2.89,0,0,1,21.6,16.673",
    transform: "translate(16.003 -0.628)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1339",
    "data-name": "Pfad 1339",
    d: "M22.7.9a7.743,7.743,0,0,1-6.93,4.285A7.748,7.748,0,0,1,8.841.9",
    transform: "translate(6.696 -0.9)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1340",
    "data-name": "Pfad 1340",
    d: "M6.051,8.292V28.564a2.891,2.891,0,0,0,2.89,2.892H26.415",
    transform: "translate(4.028 6.171)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1341",
    "data-name": "Pfad 1341",
    d: "M15.925.9h3.224a3.673,3.673,0,0,1,1.951.558",
    transform: "translate(13.473 -0.9)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1342",
    "data-name": "Pfad 1342",
    d: "M6.233,1.411A3.681,3.681,0,0,1,8.107.9h3.23",
    transform: "translate(4.202 -0.9)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1343",
    "data-name": "Pfad 1343",
    d: "M11.335,1.161,2.346,6.354A2.892,2.892,0,0,0,1.288,10.3L4.344,15.6a2.89,2.89,0,0,0,3.948,1.059l2.688-1.542",
    transform: "translate(-0.9 -0.65)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Telefon",
    d: "M20.335,19.614a23.986,23.986,0,0,1-2.141-3.694c-.378-.8-.214-.964.625-1.459s1.1-.64,1.28-.748c1.241-.724,1.245-.744.489-2.343-.455-.962-1.659-3.534-2.1-4.431a1.363,1.363,0,0,0-2.05-.533,9.507,9.507,0,0,0-2.49,2.513,6.736,6.736,0,0,0-.728,4.466,20.84,20.84,0,0,0,3.683,8.675,20.828,20.828,0,0,0,7,6.3,6.728,6.728,0,0,0,4.458.766,8.774,8.774,0,0,0,3.186-1.536,1.393,1.393,0,0,0,.163-2.11c-.57-.588-2.732-2.677-3.507-3.424-1.278-1.236-1.278-1.236-2.376-.3-.363.31-.55.469-1.122.966-.737.64-.951.713-1.584.117A23.368,23.368,0,0,1,20.335,19.614Z",
    transform: "translate(11.943 6.421)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalize);
export default __webpack_public_path__ + "static/media/personalize.52524f0107d0f210c342d67e6aa99cfa.svg";
export { ForwardRef as ReactComponent };